import { handleActions } from 'redux-actions';
import accounting from 'accounting';
import {
  getNextOnboardingStep,
  getPrevOnboardingStep,
  getNextEnabledStep,
  getPrevEnabledStep,
  getBudgetValue,
} from '../../../shared/helpers';
import { initialState } from './initialState';

const getCardInfoIndex = (state, action) => {
  const currentOnboardingSteps =
    state[action.payload.overviewStep].onboardingSteps;
  return currentOnboardingSteps.findIndex(
    elem => elem.key === action.payload.onboardingStep,
  );
};

const animationKey = 'animation';
const managementKey = 'managed_marketplace';
const budgetKey = 'budget';

function isStepEnabled(state, onboardingStepKey) {
  const { basic_information: basicInformation } = state;
  const basicRequirements = basicInformation.onboardingSteps.find(
    step => step.key === 'basic_requirements',
  );
  return basicRequirements.selectedValue.includes(onboardingStepKey);
}

/* eslint-disable */
const overview = handleActions({

    SELECT_PROJECT: (state, action) => {

        const selectedProject = action.payload.selected_project;

        if (!selectedProject) {
          return {
            ...state,
            isFetching: false,
          };
        }

        const project = {
            ...state,
            currentStep: selectedProject.current_onboarding_step || initialState.currentStep,
            finalPrice: selectedProject.final_price,
            status: selectedProject.status,
            isFetching: false,
            basic_information: {
                ...state.basic_information,
                    onboardingSteps: state.basic_information.onboardingSteps.map(
                        (content, i) => {
                            const matchElement = selectedProject.project_onboarding_infos
                              .find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                          const emptyDeadline = (content.key === 'deadline')? {project_name: undefined, project_picture: undefined}: {};
                          const emptyReferences = (content.key === 'url_link')? {references: [{ internal_id: 0, link: '', checkboxes: [], comment: '' }]}: {};

                          const step = (
                                matchElement ? {
                                    ...content,
                                    selectedValue: matchElement.question_response,
                                    project_name: content.key === 'deadline' ? selectedProject.project_name: undefined,
                                    comment: content.key === 'free_comment' ? selectedProject.comment: undefined,
                                    project_picture: content.key === 'deadline' ? selectedProject.project_picture: undefined,
                                    cards: state.basic_information.onboardingSteps[i].cards.map(
                                        contentInput => (
                                            matchElement.question_response.includes('other') ? { ...contentInput, inputValue: matchElement.input_value }
                                            : { ...contentInput, inputValue: '' }
                                        )
                                    ),
                                    status: 'done',
                                }
                                    : {
                                        ...content,
                                        ...emptyDeadline,
                                        ...emptyReferences,
                                        selectedValue: content.key === 'format' ? ['standard_size'] : [],
                                        cards: state.basic_information.onboardingSteps[i].cards.map(
                                            contentInput => (
                                                { ...contentInput, inputValue: '' }
                                            )
                                        ),
                                        status: 'empty' }
                            );

                          const { question_response: selectedValue } = selectedProject.project_onboarding_infos.find(
                            info => info.question.key === 'basic_requirements',
                          );

                          if(![animationKey].includes(step.key)){
                            return step;
                          }
                          if(step.key === animationKey){
                            return { ...step, disabled: !selectedValue.includes(animationKey)}
                          }

                          return step;
                        }
                    )
            },
            project_materials: {
                ...state.project_materials,
                    onboardingSteps: state.project_materials.onboardingSteps.map(
                        (content, i) => {

                            const matchElement = selectedProject.project_onboarding_infos
                              .find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                            return (
                                matchElement ? {
                                    ...content,
                                    selectedValue: matchElement.question_response,
                                    project_name: content.key === 'title_brief' ? selectedProject.project_name: undefined,
                                    project_brief: content.key === 'title_brief' ? selectedProject.project_brief: undefined,
                                    project_picture: content.key === 'title_brief' ? selectedProject.project_picture: undefined,
                                    attachments: content.key === 'title_brief' ? selectedProject.attachments: undefined,
                                    references: content.key === 'url_link' ? selectedProject.references ? selectedProject.references : [{ internal_id: 0, link: '', checkboxes: [], comment: '' }] : undefined,
                                    cards: state.project_materials.onboardingSteps[i].cards.map(contentInput =>
                                      (matchElement.question_response.includes('other')
                                         ? { ...contentInput, inputValue: matchElement.input_value }
                                         : { ...contentInput, inputValue: '' }
                                       )
                                    ),
                                    status: 'done',
                                } : {
                                    ...content,
                                    selectedValue: [],
                                    project_name: undefined,
                                    project_brief: undefined,
                                    project_picture: undefined,
                                    attachments: undefined,
                                    references: [{ internal_id: 0, link: '', checkboxes: [], comment: '' }],
                                    cards: state.project_materials.onboardingSteps[i].cards.map(contentInput =>
                                        ({ ...contentInput, inputValue: '' })),
                                    status: 'empty',
                                }
                            )
                        }
                    )
            },
            additional_requirements: {
                ...state.additional_requirements,
                    onboardingSteps: state.additional_requirements.onboardingSteps.map(
                        (content, i) => {

                            const matchElement = selectedProject.project_onboarding_infos.find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                            const step = (
                                matchElement
                                ?{
                                  ...content, selectedValue: matchElement.question_response,
                                  cards: state.additional_requirements.onboardingSteps[i].cards.map(
                                    contentInput => (
                                      matchElement.question_response.includes('other')
                                        ? { ...contentInput, inputValue: matchElement.input_value }
                                        : { ...contentInput, inputValue: '' }
                                      )
                                  ),
                                  status: 'done',
                                }
                                :{
                                  ...content, selectedValue: [],
                                  cards: state.additional_requirements.onboardingSteps[i].cards.map(
                                    contentInput => ({ ...contentInput, inputValue: '' })
                                  ),
                                  status: 'empty',
                                }
                            )

                            return step;

                        }
                    )
            },
            submit: {
                ...state.submit,
                    onboardingSteps: state.submit.onboardingSteps.map(
                        (content, i) => {

                            const matchElement = selectedProject.project_onboarding_infos.find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                            const step = (
                              matchElement
                                ? {
                                  ...content,
                                  selectedValue: matchElement.question_response,
                                  cards: state.submit.onboardingSteps[i].cards.map(
                                    (contentInput) => (
                                      matchElement.question_response.includes('other')
                                        ? { ...contentInput, inputValue: matchElement.input_value }
                                        : { ...contentInput, inputValue: '' }
                                    )
                                  ),
                                  status: 'done',
                                }
                                : {
                                  ...content,
                                  selectedValue: [],
                                  cards: state.submit.onboardingSteps[i].cards.map(
                                    (contentInput) => ({ ...contentInput, inputValue: '' })
                                  ), status: 'empty' }
                            )

                            const { question_response: selectedValue } = selectedProject.project_onboarding_infos.find(
                              info => info.question.key === 'basic_requirements',
                            );

                            if(![managementKey, budgetKey].includes(step.key)){
                              return step;
                            }

                            if(step.key === managementKey) {
                              const { way_to_manage: managementWay, means_of_contact, phone_number, email } = selectedProject;

                              const isMarketplace = managementWay === 'marketplace';
                              const current_section = isMarketplace? 0 : 1;
                              const contactInfo = means_of_contact === 'email'
                                ? [{ means_of_contact }, { email }]
                                : [{ means_of_contact }, { phone_number }];

                              const hero = 'Congrats!';
                              const description= 'You’ve been upgraded to our Managed Service at no extra cost to you!';

                              const [ managementChoiceCard, managementWayCard] = step.cards;

                              return {
                                ...step,
                                current_section,
                                endEarly: !isMarketplace,
                                selectedValue: [...contactInfo, { way_to_manage: managementWay }],
                                status: means_of_contact? 'done': 'empty',
                                cards: [managementChoiceCard, {...managementWayCard, hero, description}]
                              }
                            }

                          if(step.key === budgetKey) {

                            const { price_selected: budget } = selectedProject;
                            return {
                              ...step,
                              selectedValue: budget? [accounting.format(budget)]: [],
                              status: budget? 'done': 'empty',
                            }

                            const project = {
                              ...state,
                              currentStep: selectedProject.current_onboarding_step || initialState.currentStep,
                              finalPrice: selectedProject.final_price,
                              isFetching: false,
                              basic_information: {
                                ...state.basic_information,
                                onboardingSteps: state.basic_information.onboardingSteps.map(
                                  (content, i) => {
                                    const matchElement = selectedProject.project_onboarding_infos
                                      .find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                                    const emptyDeadline = (content.key === 'deadline')? {project_name: undefined, project_picture: undefined}: {};

                                    const step = (
                                      matchElement ? {
                                          ...content,
                                          selectedValue: matchElement.question_response,
                                          project_name: content.key === 'deadline' ? selectedProject.project_name: undefined,
                                          project_picture: content.key === 'deadline' ? selectedProject.project_picture: undefined,
                                          cards: state.basic_information.onboardingSteps[i].cards.map(
                                            contentInput => (
                                              matchElement.question_response.includes('other') ? { ...contentInput, inputValue: matchElement.input_value }
                                                : { ...contentInput, inputValue: '' }
                                            )
                                          ),
                                          status: 'done',
                                        }
                                        : {
                                          ...content,
                                          ...emptyDeadline,
                                          selectedValue: [],
                                          cards: state.basic_information.onboardingSteps[i].cards.map(
                                            contentInput => (
                                              { ...contentInput, inputValue: '' }
                                            )
                                          ),
                                          status: 'empty' }
                                    );

                                    const { question_response: selectedValue } = selectedProject.project_onboarding_infos.find(
                                      info => info.question.key === 'basic_requirements',
                                    );

                                    if(![animationKey].includes(step.key)){
                                      return step;
                                    }
                                    if(step.key === animationKey){
                                      return { ...step, disabled: !selectedValue.includes(animationKey)}
                                    }

                                    return step;
                                  }
                                )
                              },
                              project_materials: {
                                ...state.project_materials,
                                onboardingSteps: state.project_materials.onboardingSteps.map(
                                  (content, i) => {

                                    const matchElement = selectedProject.project_onboarding_infos
                                      .find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                                    return (
                                      matchElement ? {
                                        ...content,
                                        selectedValue: matchElement.question_response,
                                        project_name: content.key === 'title_brief' ? selectedProject.project_name: undefined,
                                        project_brief: content.key === 'title_brief' ? selectedProject.project_brief: undefined,
                                        project_picture: content.key === 'title_brief' ? selectedProject.project_picture: undefined,
                                        attachments: content.key === 'title_brief' ? selectedProject.attachments: undefined,
                                        references: content.key === 'url_link' ? selectedProject.references ? selectedProject.references : [{ internal_id: 0, link: '', checkboxes: [], comment: '' }] : undefined,
                                        cards: state.project_materials.onboardingSteps[i].cards.map(contentInput =>
                                          (matchElement.question_response.includes('other')
                                              ? { ...contentInput, inputValue: matchElement.input_value }
                                              : { ...contentInput, inputValue: '' }
                                          )
                                        ),
                                        status: 'done',
                                      } : {
                                        ...content,
                                        selectedValue: [],
                                        project_name: undefined,
                                        project_brief: undefined,
                                        project_picture: undefined,
                                        attachments: undefined,
                                        references: [{ internal_id: 0, link: '', checkboxes: [], comment: '' }],
                                        cards: state.project_materials.onboardingSteps[i].cards.map(contentInput =>
                                          ({ ...contentInput, inputValue: '' })),
                                        status: 'empty',
                                      }
                                    )
                                  }
                                )
                              },
                              additional_requirements: {
                                ...state.additional_requirements,
                                onboardingSteps: state.additional_requirements.onboardingSteps.map(
                                  (content, i) => {

                                    const matchElement = selectedProject.project_onboarding_infos.find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                                    const step = (
                                      matchElement
                                        ?{
                                          ...content, selectedValue: matchElement.question_response,
                                          cards: state.additional_requirements.onboardingSteps[i].cards.map(
                                            contentInput => (
                                              matchElement.question_response.includes('other')
                                                ? { ...contentInput, inputValue: matchElement.input_value }
                                                : { ...contentInput, inputValue: '' }
                                            )
                                          ),
                                          status: 'done',
                                        }
                                        :{
                                          ...content, selectedValue: [],
                                          cards: state.additional_requirements.onboardingSteps[i].cards.map(
                                            contentInput => ({ ...contentInput, inputValue: '' })
                                          ),
                                          status: 'empty',
                                        }
                                    )

                                    return step;

                                  }
                                )
                              },
                              submit: {
                                ...state.submit,
                                onboardingSteps: state.submit.onboardingSteps.map(
                                  (content, i) => {

                                    const matchElement = selectedProject.project_onboarding_infos.find((elem) => elem.question.key === content.key && elem.question_response.length > 0);

                                    const step = (
                                      matchElement
                                        ? {
                                          ...content,
                                          selectedValue: matchElement.question_response,
                                          cards: state.submit.onboardingSteps[i].cards.map(
                                            (contentInput) => (
                                              matchElement.question_response.includes('other')
                                                ? { ...contentInput, inputValue: matchElement.input_value }
                                                : { ...contentInput, inputValue: '' }
                                            )
                                          ),
                                          status: 'done',
                                        }
                                        : {
                                          ...content,
                                          selectedValue: [],
                                          cards: state.submit.onboardingSteps[i].cards.map(
                                            (contentInput) => ({ ...contentInput, inputValue: '' })
                                          ), status: 'empty' }
                                    );

                                    const { question_response: selectedValue } = selectedProject.project_onboarding_infos.find(
                                      info => info.question.key === 'basic_requirements',
                                    );

                                    if(![managementKey, budgetKey].includes(step.key)){
                                      return step;
                                    }

                                    if(step.key === managementKey) {
                                      const { way_to_manage: managementWay, means_of_contact, phone_number, email } = selectedProject;

                                      const isMarketplace = managementWay === 'marketplace';
                                      const current_section = isMarketplace? 0 : 1;
                                      const contactInfo = means_of_contact === 'email'
                                        ? [{ means_of_contact }, { email }]
                                        : [{ means_of_contact }, { phone_number }];

                                      const hero = 'Congrats!';
                                      const description= 'You’ve been upgraded to our Managed Service at no extra cost to you!';

                                      const [ managementChoiceCard, managementWayCard] = step.cards;

                                      return {
                                        ...step,
                                        current_section,
                                        endEarly: !isMarketplace,
                                        selectedValue: [...contactInfo, { way_to_manage: managementWay }],
                                        status: means_of_contact? 'done': 'empty',
                                        cards: [managementChoiceCard, {...managementWayCard, hero, description}]
                                      }
                                    }

                                    if(step.key === budgetKey) {

                                      const { price_selected: budget } = selectedProject;
                                      return {
                                        ...step,
                                        selectedValue: budget? [accounting.format(budget)]: [],
                                        status: budget? 'done': 'empty',
                                      }

                                    }

                                  }
                                )
                              },
                            };

                            return project;}

                        }
                    )
            },
        };

        return project;

    },

    SELECT_PROJECT_REQUEST: state => ({...state, isFetching: true,}),

    SET_CURRENT_SECTION: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

        return {
            ...state,
            [action.payload.overviewStep]: {
                ...state[action.payload.overviewStep],
                onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
                    (content, i) => i === cardInfoIndex ? { ...content, current_section: action.payload.sectionToGo }
                        : content
                )
            }
        }

    },

    UPDATE_PROJECT_BRIEF: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, [action.payload.inputField]: action.payload.inputValue }
              : content
          ),
        },
      }

    },

    UPLOAD_PROJECT_BRIEF_ATTACHMENT: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);
      const { overviewStep, file } = action.payload;
      return {
        ...state,
        [overviewStep]: {
          ...state[overviewStep],
          onboardingSteps: state[overviewStep].onboardingSteps.map((content, i) => {
          const prevAttachments = content.attachments || [];
          return i === cardInfoIndex ? { ...content, attachments: [...prevAttachments, { ...file }] }
            : content
          }),
        },
        isUploadingAttachment: false,
      }

    },

    UPLOAD_PROJECT_PICTURE: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, project_picture:action.payload.file.url }
              : content
          ),
        },
        isUploadingProjectPicture: false,
      }
    },

    REMOVE_PROJECT_PICTURE: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, project_picture:null }
              : content
          ),
        },
        isUploadingProjectPicture: false,
      }
    },

    ADD_DROPBOX_PATH: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, dropboxPaths: action.payload.links }
              : content
          ),
        },
      }
    },

    REMOVE_DROPBOX_FOLDER: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, dropboxPath: null }
              : content
          ),
        },
      }
    },

    UPLOADING_ATTACHMENT_REQUEST: state => ({...state, isUploadingAttachment: true}),

    UPLOADING_PROJECT_PICTURE_REQUEST: state => ({...state, isUploadingProjectPicture: true}),

    REMOVE_PROJECT_BRIEF_ATTACHMENT: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);
      const { attachment } = action.payload;

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, attachments:[...content.attachments.filter(f => f.url !== attachment.url), {...attachment, "_destroy": true }] }
              : content
          ),
        },
      }

    },

    ADD_REFERENCE: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);
      const finalReferences = state[action.payload.overviewStep].onboardingSteps[cardInfoIndex].references;

        finalReferences.push(action.payload.newElement);
        return {
          ...state,
          [action.payload.overviewStep]: {
            ...state[action.payload.overviewStep],
            onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
              (content, i) => i === cardInfoIndex ? { ...content, references: finalReferences, selectedValue: finalReferences.map(r => r.link)}
                : content
            )
          }
        }
    },

    DELETE_REFERENCE: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);
      const references = state[action.payload.overviewStep].onboardingSteps[cardInfoIndex].references;
      const { reference } = action.payload;
      const finalReferences = references.filter(ref => ref.link !== reference.link);
      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, references: finalReferences, selectedValue: finalReferences.map(r => r.link)}
              : content
          )
        }
      }
    },

    UPDATE_REFERENCE: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

        const finalReferences = state[action.payload.overviewStep].onboardingSteps[cardInfoIndex].references.map((elem) => {
            if (elem.internal_id === action.payload.index){
                if (action.payload.inputField === 'checkboxes') {
                    if(elem.checkboxes.includes(action.payload.inputValue)){
                        elem.checkboxes.splice(elem.checkboxes.indexOf(action.payload.inputValue), 1);
                    } else {
                        elem.checkboxes.push(action.payload.inputValue)
                    }
                } else {
                    elem[action.payload.inputField] = action.payload.inputValue
                }
            }
            return elem;
        });

        return {
            ...state,
            [action.payload.overviewStep]: {
                ...state[action.payload.overviewStep],
                onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
                    (content, i) => i === cardInfoIndex ? { ...content, references: finalReferences, selectedValue: finalReferences.map(r => r.link) }
                        : content
                )
            }
        }

    },

    UPDATE_FREE_COMMENT: (state, action) => {
      const cardInfoIndex = getCardInfoIndex(state, action);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, comment: action.payload.inputValue, selectedValue: [action.payload.inputValue] }
              : content
          )
        }
      }

    },

    REQUEST_NEXT_STEP: state => {
        return {...state, isFetching: true}
    },

    SET_NEXT_STEP: (state, action) => {
      const actualStep = state.currentStep;
      const currentOnboardingSteps = state[action.payload.overviewStep].onboardingSteps;
      const cardInfoIndex = currentOnboardingSteps.findIndex((elem) => elem.key === actualStep);

      return {
        ...state,
        currentStep: getNextEnabledStep(currentOnboardingSteps, getNextOnboardingStep(actualStep)),
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? { ...content, status: 'done' }
              : content
          )
        },
        isFetching: false,
      }
    },

    SET_PREV_STEP: (state, action) => {
      const actualStep = state.currentStep;

      const currentOnboardingSteps = state[action.payload.overviewStep].onboardingSteps;

      return {...state,
        currentStep: getPrevEnabledStep(currentOnboardingSteps, getPrevOnboardingStep(actualStep))
      };
    },

    SET_CURRENT_ONBOARDING_STEP: (state, action) => {
      return {
        ...state,
        currentStep: action.payload.currentStep,
      }
    },

    SELECT_STEP_VALUE: (state, action) => {
      const actualStep = state.currentStep;
      const currentOnboardingSteps = state[action.payload.overviewStep].onboardingSteps;
      const cardInfoIndex = currentOnboardingSteps.findIndex((elem) => elem.key === actualStep);

      const enableAnimation = isStepEnabled(state, animationKey);

      const onboardingState = {
        ...state,
        [action.payload.overviewStep]: {
            ...state[action.payload.overviewStep],
            onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
                (content, i) => i === cardInfoIndex ? { ...content, selectedValue: action.payload.selectedValue }
                    : content
            )
        }
      };

      return {
        ...onboardingState,
        basic_information: {
        ...onboardingState.basic_information,
          onboardingSteps: onboardingState.basic_information.onboardingSteps.map(step => {
            if(![animationKey].includes(step.key)){
              return step;
            }
            if(step.key === animationKey){
              return { ...step, disabled: !enableAnimation }
            }
          })
        },
        submit: {
          ...onboardingState.submit
        }

      }
    },

    SELECT_STEP_INPUT_VALUE: (state, action) => {

      const findStepCard = (elem) => elem.key === actualStep;
      const findCard = (elem) => action.payload.selectedValue.includes(elem.value);

      const actualStep = state.currentStep;
      const currentOnboardingSteps = state[action.payload.overviewStep].onboardingSteps;
      const card = currentOnboardingSteps.find(findStepCard);
      const cardInfoIndex = currentOnboardingSteps.findIndex(findStepCard);
      const isMulti = card.type === 'multi';

      const cardInputIndex = !isMulti
        ? currentOnboardingSteps[cardInfoIndex].cards.findIndex(findCard)
        : card.current_section;

      const innerCardInputIndex = isMulti && currentOnboardingSteps[cardInfoIndex].cards[card.current_section].inner_cards.findIndex(findCard);

      return {
        ...state,
        [action.payload.overviewStep]: {
          ...state[action.payload.overviewStep],
          onboardingSteps: state[action.payload.overviewStep].onboardingSteps.map(
            (content, i) => i === cardInfoIndex ? {
              ...content,
              cards: state[action.payload.overviewStep].onboardingSteps[cardInfoIndex].cards.map(
                (cardContent, i) => i === cardInputIndex
                  ? {
                  ...cardContent,
                  inputValue: action.payload.inputValue,
                  inner_cards: isMulti
                    ? cardContent.inner_cards.map((inner,j) => innerCardInputIndex === j
                      ? {...inner, inputValue: action.payload.inputValue}
                      : inner
                    )
                    : cardContent.inner_cards,
                  }
                  : cardContent)}
              : content,
          )
        }
      }
    },

    SAVE_PROJECT_REQUEST: state => ({
      ...state,
      isSavingProject: true,
      isFetching: true,
    }),

    SAVE_PROJECT_SUCCESS: state => ({
      ...state,
      isSavingProject: false,
      isFetching: false,
    }),

    SAVE_PROJECT_FAILURE: state => ({
      ...state,
      isSavingProject: false
    }),

    SET_BUDGET: (state, action) => ({
      ...state,
      budget: getBudgetValue(action.payload.data, state.recommendedBudget),
    }),

    GET_BUDGET_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),

    GET_BUDGET_SUCCESS: (state, action) => ({
      ...state,
      budget: action.payload.data.recommended,
      minBudget: action.payload.data.minimum,
      maxBudget: action.payload.data.maximum,
      recommendedBudget: action.payload.data.recommended,
      isFetching: false,
    }),

    GET_BUDGET_FAILURE: state => ({
      ...state,
      isFetching: false
    }),

    CHANGE_MANAGEMENT_DESCRIPTION: (state, action)  => ({
      ...state,
      submit: {
        ...state.submit,
        onboardingSteps: state.submit.onboardingSteps.map(step => {
          if(![managementKey].includes(step.key)){
            return step;
          }
          if(step.key === managementKey){
            const isMarketplace = action.payload.managementWay === 'marketplace';
            const [ managementChoice, managementWay ] = step.cards;

            const hero = isMarketplace? managementWay.hero: 'We Agree!';
            const description=isMarketplace? managementWay.description :'This project is better suited for our managed service!';
            const current_section = isMarketplace? 1 : step.current_section;

            return { ...step, endEarly: !isMarketplace, current_section, cards: [managementChoice, {...managementWay, hero, description}]}
          }
        })
      }
    }),

    FETCHING_FREELANCERS_REQUEST: state => ({
      ...state,
      isFetchingFreelancers: true,
    }),

    FETCHING_FREELANCERS_SUCCESS: (state, action) => ({
      ...state,
      freelancersPage: {
        ...state.freelancersPage,
        ...action.payload.data
      },
      isFetchingFreelancers: false,
    }),

    FETCHING_FREELANCERS_FAILURE: state => ({
      ...state,
      isFetchingFreelancers: false,
    }),

    UPDATE_FREELANCER_PRE_FILTER: (state, action) => ({
      ...state,
      freelancersPage: {
        ...state.freelancersPage,
        preFilter: action.payload.data,
      }
    }),

    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState
);

export default overview;
export { initialState };



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/index.js